export default "__VITE_ASSET__213e74e1__"